/* ==========================================================================
   FF Cart Page — WIP theme 191898976578 ONLY.
   v2.2 (2026-08-12): summary hooks are CLASS-based (the summary HTML renders
   twice — desktop rail + mobile card — so ids would collide): protection-box
   toggle (.ff-protect-toggle, dedupe), coverage modal openers
   (.ff-warranty-modal-open), save/share cart (.ff-savecart-btn). The cart-only
   header's live item count (.ff-cart-header-count [data-ff-header-count]) is
   refreshed after every AJAX add/remove. Qty/remove stay on the theme's stock
   cart.min.js via the standard quantity-input / cart-remove-button markup.
   Wave-5 (2026-08-12): lightbox Add-to-cart (+ collection-style ffToast) and
   save/share phone support (email OR phone, contact[phone] + body echo).
   ========================================================================== */
(function () {
  "use strict";

  /* wave-4 helpers: parse "$1,234.56" -> cents, format cents -> "$1,234.56"
     (CAD, matches the money filter output on this store). */
  function ffParseCents(str) {
    var digits = (str || "").replace(/[^0-9]/g, "");
    return parseInt(digits || "0", 10);
  }
  function ffFmtMoney(cents) {
    if (!isFinite(cents) || cents < 0) cents = 0;
    var v = (cents / 100).toFixed(2).split(".");
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "$" + v[0] + "." + v[1];
  }

  /* wave-5: "Added to cart ✓" toast — same element id/class + timing as the
     collection quick-add toast (card-product.liquid ffQaToast), so the two
     surfaces feel identical and can never stack two toasts. */
  function ffToast(msg) {
    var t = document.getElementById("ff-qa-toast");
    if (!t) {
      t = document.createElement("div");
      t.id = "ff-qa-toast";
      t.className = "ff-qa-toast";
      t.setAttribute("role", "status");
      t.setAttribute("aria-live", "polite");
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.remove("is-visible");
    void t.offsetWidth; /* restart the transition on rapid re-adds */
    t.classList.add("is-visible");
    if (window.__ffQaToastTimer) { clearTimeout(window.__ffQaToastTimer); }
    window.__ffQaToastTimer = setTimeout(function () { t.classList.remove("is-visible"); }, 2500);
  }

  /* ---------- FF 2026-08-17 [wip358 owner item 3] ----------
     REVERSES wip170/WAVE 6's "the cart drawer is the confirmation on EVERY add,
     the cart page's own rails included" decision -- for THIS FILE specifically.
     Tyson: adding an item from the CART PAGE itself (rail card, category popup,
     "Add all") should never pop the "Added to cart" drawer over a page the
     shopper is already looking at -- update the page's own sections in place
     instead. assets/ff-cart.js only ever loads on /cart (see the file banner at
     the very top of this file), so every caller of ffCartAfterAdd -- the
     rail-card lightbox add below, and window.FFCart.afterAdd as called by
     assets/ff-cart-goeswith.js's tile-add / Add-all handlers (read-only
     reference, not edited) -- is BY CONSTRUCTION a cart-page add. There is no
     "other page" branch to preserve here; every one of those callers already
     calls refreshCartSections() immediately after this function returns, which
     does the real "update the page in place" work (full .ff-cart-grid replace:
     rail, mobile summary, and the "Goes with X" block, re-anchored fresh). A
     plain toast confirms the add without covering anything.
     snippets/cart-drawer.liquid itself is UNTOUCHED here -- it still opens
     normally for every OTHER add-to-cart surface on the site (PDP, collection
     quick-add, etc.); this only changes what happens after an add that
     originated on THIS page. Its own drawer-opening safety net
     (window.__ffLastAddIsHero, reset to false on every full page load by
     cart-drawer.liquid's own script) is left alone deliberately -- as long as
     this file never sets it back to true, that net naturally stays closed for
     cart-page adds without needing to touch the drawer snippet at all. ---------- */
  function ffCartAfterAdd(response) {
    document.dispatchEvent(new CustomEvent("ff:cart-badge-bump"));
    /* Kept for any other listener that cares an add happened (e.g. the wip332
       cart:updated guard a bit further down in this file, which already skips
       its own refresh for this exact source so nothing double-fires) -- but no
       longer used to re-arm a drawer force-open, since none of this file's
       callers want the drawer to open at all now. */
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { source: "ff-cart-page-add" } }));
    ffToast("Added to cart ✓");
  }

  function updateHeaderCount(doc) {
    var freshBar = (doc || document).querySelector("#ff-cart-sticky-bar");
    var countEl = document.querySelector(".ff-cart-header-count [data-ff-header-count]");
    if (!freshBar || !countEl) return;
    var n = parseInt(freshBar.dataset.itemCount || "0", 10);
    countEl.textContent = n + (n === 1 ? " item" : " items");
  }

  function refreshCartSections(cb) {
    fetch(window.Shopify.routes.root + "?sections=main-cart-items,main-cart-footer,cart-icon-bubble,ff-cart-rails")
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        /* FF-WIP533 PHASE 3/4: re-parse the rail data map on every post-mutation
           refresh too (not just once at page load) -- the cart's contents just
           changed, so the "already in cart" dedupe guard (ffGwInCart, below)
           needs a fresh read either way, and this rides the SAME fetch call
           the section refresh already makes rather than adding a second
           request. The legacy window.FF_UPSELL_COMPANIONS fallback is gone
           (Phase 4) -- a missing/unparseable key here just means no rail
           update this refresh, same as any other empty-rail case. */
        ffCartRailsApplySection(sections["ff-cart-rails"]);
        var doc = null;
        if (sections["main-cart-items"]) {
          doc = new DOMParser().parseFromString(sections["main-cart-items"], "text/html");
          var newGrid = doc.querySelector(".ff-cart-grid");
          var oldGrid = document.querySelector(".ff-cart-grid");
          if (newGrid && oldGrid) {
            oldGrid.replaceWith(newGrid);
          }
          var newTitle = doc.querySelector(".ff-cart-title");
          var oldTitle = document.querySelector(".ff-cart-title");
          if (newTitle && oldTitle) oldTitle.textContent = newTitle.textContent;

          var newBar = doc.querySelector("#ff-cart-sticky-bar");
          var oldBar = document.querySelector("#ff-cart-sticky-bar");
          if (newBar && oldBar) oldBar.replaceWith(newBar);
          updateHeaderCount(document);
        }
        var cartIconBubble = document.querySelector("#cart-icon-bubble");
        if (cartIconBubble && sections["cart-icon-bubble"]) {
          var parsedCartIcon = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html")
            .querySelector("#cart-icon-bubble");
          if (parsedCartIcon) cartIconBubble.replaceWith(parsedCartIcon);
        }
        if (typeof cb === "function") cb();
        initStickyBar();
        /* .ff-cart-grid is replaced wholesale above — re-run the "goes with"
           block's fetch+render against the fresh (freshly-[hidden]) markup.
           FF 2026-08-14 [wip314 goeswith]: was initUpsellRails() (old rail
           arrows, removed with the old "Finish the room" rails). Guarded
           because assets/ff-cart-goeswith.js (deferred, loads after this
           file) sets window.FFCart.initGoesWith — see the exposure at the
           bottom of this file. */
        if (window.FFCart && window.FFCart.initGoesWith) { window.FFCart.initGoesWith(); }
        /* FF 2026-08-17 [wip358 owner item 1]: .ff-cart-grid was just replaced
           wholesale above with fresh server-rendered HTML -- the family-match
           injection below needs to re-run against it every time, same as
           initGoesWith() just above. */
        ffGwInjectFamily();
        /* FF 2026-08-17 [wip373 owner item 5]: same defensive re-close as
           initGoesWith() does for the category overlay above -- the fresh
           markup already renders #ff-quickview-cart-overlay [hidden] by
           default, this just guards the (unlikely) case a quick-view was
           mid-open across the async gap before the replace landed. */
        ffQvClose();
      })
      .catch(function (e) { console.error("FF cart: refresh failed", e); });
  }

  /* ---------- FF 2026-08-17 [wip358 owner item 1] ----------
     RAIL QUALITY: the "Goes with the {anchor}" rail must lead with the SAME
     family items the PDP's own "Complete the room" shows, tagged with the same
     green MATCHES badge, before the curated category picks. The Liquid pass in
     sections/main-cart-items.liquid can only find a same-family companion if it
     happens to already be a member of one of the 6 fixed category collections
     (a real gap -- e.g. confirmed live that Cuddle Plush's own swivel accent
     chair is NOT in the "Accent Chairs" collection, so the server-side scan can
     never surface it, see SPEC/CART.md's wip338 Known-gap #19). Liquid cannot
     fix this on its own -- there is no live cross-catalog metafield join in
     this templating language (confirmed in the PDP's own code comment,
     sections/ff-main-product-redesign.liquid, read-only reference). The PDP
     solves the identical problem by precomputing the join offline into
     assets/ff-upsell-companions.js (window.FF_UPSELL_COMPANIONS[handle] =
     {fam, items:[{h,t,p,c,img,vid,avail}, ...]}, already gated on "2+ distinct
     ffc.piece_type values" when it was built) and blending it in client-side,
     ahead of its own server-rendered tier-2 cards. This function mirrors that
     exact blend pattern for the cart's rail: real family companions (from the
     SAME precomputed, read-only data set the PDP uses -- nothing here invents
     or re-derives a match) are prepended to the already-rendered "Most
     Popular" grid with a MATCHES badge, deduped by product handle against
     whatever Liquid already picked, then the grid is trimmed back down to the
     existing 5-card cap (dropping from the END -- i.e. the lowest-priority
     curated picks give way to real family matches first). The visible
     "Add all N items · $X" line is server-rendered ONCE and does not
     recompute on its own (see sections/main-cart-items.liquid's own comment on
     that block) -- recomputed here from the grid's actual final contents so it
     never goes stale after an injection. The existing document-delegated
     .ff-goeswith-tile-add / Add-all handlers (assets/ff-cart-goeswith.js,
     read-only reference) need no changes -- both already work off
     data-variant-id read live from the DOM, not a fixed list captured at page
     load. ---------- */
  function ffMoney(n) {
    if (n == null || isNaN(n)) return "";
    try { return "$" + Number(n).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return "$" + Number(n).toFixed(2); }
  }
  function ffMoneyNoCents(n) {
    if (n == null || isNaN(n)) return "";
    var d = Math.floor(Number(n));
    try { return "$" + d.toLocaleString("en-CA"); } catch (e) { return "$" + d; }
  }
  function ffEsc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : s;
    return d.innerHTML;
  }
  /* FF FIX (2026-08-22, wip516): real per-image aspect for JS-built family tiles.
     window.FF_UPSELL_COMPANIONS carries {h,t,p,c,img,vid,r,avail}, NO productType and NO
     aspect-ratio field, so this file's ONLY prior fit signal was a title-keyword guess for
     the vertical anchor (low-table/lamp) -- it never decided cover-vs-contain at all, every
     JS-built tile here always rendered plain cover, unconditionally.
     Owner complaint (live, cuddle-plush-sectional rail) plus a SEPARATE live bug found while
     verifying that fix on THIS surface: the cart page's own "Most Popular" grid -- built by
     this exact function -- rendered a real portrait product (Realyn Chair Side End Table,
     ffwip.card_image_aspect 0.7023, well outside the 0.8-2.0 cover band) with plain cover and
     no contain class at all, because this function never computed or applied one. Fixed the
     same way as the PDP's tier-1 rail (sections/ff-main-product-redesign.liquid, same wave):
     every JS-built tile now starts contain-fit (the safe default -- assets/ff-cart.css's
     .ff-goeswith-tile-img.is-contain rule, already used by the Liquid-rendered tiles for the
     exact same purpose), and ffGwOnImgLoad (below) measures the REAL naturalWidth/
     naturalHeight the instant the image loads and removes is-contain (upgrading to cover)
     only when that real aspect falls inside the same 0.8-2.0 band ff-card-data.liquid /
     ff-goeswith-card.liquid / the tier-2 PDP rail all use. The tile's box (.ff-goeswith-tile-
     img, fixed aspect-ratio:16/10 box, overflow hidden) never resizes either way, so this
     cannot shift layout. */
  function ffGwClassifyTitle(title) {
    var t = (title || "").toLowerCase();
    if (t.indexOf("coffee table") !== -1 || t.indexOf("cocktail table") !== -1 || t.indexOf("occasional table") !== -1 || t.indexOf("end table") !== -1 || t.indexOf("side table") !== -1) {
      return " ff-card-anchor-lowtable";
    }
    if (t.indexOf("lamp") !== -1) {
      return " ff-card-anchor-hightop";
    }
    return "";
  }
  function ffGwOnImgLoad(img) {
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    var aspect = img.naturalWidth / img.naturalHeight;
    if (aspect >= 0.8 && aspect <= 2.0) {
      var wrap = img.closest(".ff-goeswith-tile-img");
      if (wrap) wrap.classList.remove("is-contain");
    }
  }
  window.ffGwOnImgLoad = ffGwOnImgLoad;
  function ffGwBuildFamilyTile(it) {
    var was = it.c && it.c > it.p ? "<s>" + ffMoneyNoCents(it.c) + "</s>" : "";
    var imgSrc = it.img ? (it.img + (it.img.indexOf("?") === -1 ? "?" : "&") + "width=420") : "";
    var anchorCls = ffGwClassifyTitle(it.t);
    var div = document.createElement("div");
    div.className = "ff-goeswith-tile";
    div.setAttribute("data-variant-id", it.vid || "");
    div.setAttribute("data-ff-gw-handle", it.h || "");
    div.setAttribute("data-handle", it.h || "");
    div.setAttribute("data-price", it.p);
    div.setAttribute("data-ff-cr-handle", it.h || "");
    div.setAttribute("data-ff-track", JSON.stringify({ s: "most_popular", c: "", p: it.p, fm: true, li: !!it.img, hr: false }));
    /* FF 2026-08-17 [wip373 owner item 5]: quick-view payload for JS-built family
       tiles too -- window.FF_UPSELL_COMPANIONS (the PDP's precomputed asset, read-
       only here) only carries {h,t,p,c,img,vid,avail}, no images[]/rating/dims/
       description, so this payload is honestly DEGRADED vs. the server-rendered
       cards' richer one (single image, no stars, no dims/desc row) -- the popup
       itself hides whatever fields are missing rather than showing a blank/fake
       value. Flagged in VERIFICATION.md as a real, stated limitation. */
    var qvPayload = {
      h: it.h || "",
      t: it.t || "",
      url: "/products/" + (it.h || ""),
      price: ffMoney(it.p),
      compare: it.c && it.c > it.p ? ffMoneyNoCents(it.c) : null,
      images: imgSrc ? [imgSrc] : [],
      rating: null,
      dims: "",
      desc: null,
      vid: it.vid || ""
    };
    div.setAttribute("data-ff-qv", JSON.stringify(qvPayload));
    div.innerHTML =
      '<a href="/products/' + ffEsc(it.h) + '" class="ff-goeswith-tile-img is-contain" tabindex="-1" data-ff-qv-trigger>' +
        '<span class="ff-goeswith-tile-badge">Matches</span>' +
        (imgSrc ? '<img src="' + imgSrc + '" width="420" height="263" loading="lazy" alt="' + ffEsc(it.t) + '"' + (anchorCls ? ' class="' + anchorCls.replace(/^\s+/, "") + '"' : "") + ' onload="window.ffGwOnImgLoad(this)">' : "") +
      "</a>" +
      '<a href="/products/' + ffEsc(it.h) + '" class="ff-goeswith-tile-title" data-ff-qv-trigger>' + ffEsc(it.t) + "</a>" +
      '<div class="ff-goeswith-tile-row">' +
        '<div class="ff-goeswith-tile-price"><span>' + ffMoney(it.p) + "</span>" + was + "</div>" +
        '<button type="button" class="ff-goeswith-tile-add" data-variant-id="' + (it.vid || "") + '" aria-label="Add ' + ffEsc(it.t) + ' to cart"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></button>' +
      "</div>";
    return div;
  }
  function ffGwUpdateAddAll(root) {
    var grid = root.querySelector("[data-ff-gw-grid]");
    var addall = root.querySelector("[data-ff-gw-addall]");
    if (!grid || !addall) return;
    var tiles = grid.querySelectorAll(".ff-goeswith-tile[data-variant-id]");
    var count = 0, total = 0;
    tiles.forEach(function (t) {
      var priceEl = t.querySelector(".ff-goeswith-tile-price span");
      if (!priceEl) return;
      var cents = parseFloat((priceEl.textContent || "").replace(/[^0-9.]/g, ""));
      if (!isNaN(cents)) { total += cents; count++; }
    });
    var countEl = addall.querySelector("[data-ff-gw-addall-count]");
    var priceEl2 = addall.querySelector("[data-ff-gw-addall-price]");
    if (countEl) countEl.textContent = count + (count === 1 ? " item" : " items");
    if (priceEl2) priceEl2.textContent = ffMoney(total);
  }
  /* FF 2026-08-21 [wip493 Bug A]: cheap title-keyword TONE classifier -- this
     function was blending window.FF_UPSELL_COMPANIONS items into the cart rail
     with ZERO finish/colour check (only `it.avail`), which is the actual root
     cause of the "White Cuddle Plush sectional recommends a Black TV stand"
     bug: this is the function that put it there, unconditionally, every page
     load and every post-add-to-cart refresh, ahead of anything sections/
     main-cart-items.liquid's own (now tone-guarded) Liquid picks could do about
     it. Hard-clash guard only, not a full colour system -- see sections/
     main-cart-items.liquid's own copy of this same classifier for the full
     writeup. Anchor tone reads the data-anchor-tone-hay attribute (product
     title + the actual cart line's selected variant title, e.g. "White / 2 Pc.
     Sectional") that section now renders on the [data-ff-goeswith] root. */
  var FF_GW_DARK = ["black", "espresso", "charcoal", "ebony", "onyx", "matte black"];
  var FF_GW_LIGHT = ["white", "ivory", "cream", "snow", "arctic", "alabaster", "blanc", "pearl", "bone"];
  function ffGwTone(text) {
    var t = (text || "").toLowerCase();
    for (var i = 0; i < FF_GW_DARK.length; i++) { if (t.indexOf(FF_GW_DARK[i]) !== -1) return "dark"; }
    for (var i2 = 0; i2 < FF_GW_LIGHT.length; i2++) { if (t.indexOf(FF_GW_LIGHT[i2]) !== -1) return "light"; }
    return "neutral";
  }
  function ffGwToneClash(a, b) { return (a === "dark" && b === "light") || (a === "light" && b === "dark"); }
  /* FF-WIP533 PHASE 3/4: shared parse step for the ff-cart-rails section's
     hidden <script id="FFCartRailsData"> payload -- used both by the initial
     page-load fetch below and by refreshCartSections' piggybacked fetch
     above. Safe to call with undefined/malformed input (initial load and any
     fetch failure both leave window.__ffCartRailsMap unset -- Phase 4 removed
     the legacy global, so that just means no rail this load/refresh). */
  function ffCartRailsApplySection(html) {
    if (!html) return;
    var m = html.match(/<script[^>]*id=["']FFCartRailsData["'][^>]*>([\s\S]*?)<\/script>/);
    if (!m) return;
    try { window.__ffCartRailsMap = JSON.parse(m[1]); } catch (e) { /* leave unset */ }
  }
  function ffCartRailsFetchInitial() {
    if (window.__ffCartRailsFetchStarted) return;
    window.__ffCartRailsFetchStarted = true;
    fetch(window.Shopify.routes.root + "?sections=ff-cart-rails")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        ffCartRailsApplySection(d && d["ff-cart-rails"]);
        ffGwInjectFamily();
      })
      .catch(function () { /* leave window.__ffCartRailsMap unset -- fallback handles it */ });
  }
  function ffGwInjectFamily() {
    var root = document.querySelector("[data-ff-goeswith]");
    if (!root) return;
    var handle = root.getAttribute("data-anchor-handle");
    /* FF-WIP533 PHASE 4: metafield-only now -- the legacy global fallback
       (window.FF_UPSELL_COMPANIONS / assets/ff-upsell-companions.js) is gone. */
    var map = window.__ffCartRailsMap;
    var entry = handle && map ? map[handle] : null;
    if (!entry || !entry.items || !entry.items.length) return;
    var grid = root.querySelector("[data-ff-gw-grid]");
    if (!grid) return;
    var anchorTone = ffGwTone(root.getAttribute("data-anchor-tone-hay") || "");
    /* FF 2026-08-17 [wip373 owner item 2]: SIX cards, always -- was 5, matching
       the Liquid-side cap raise in sections/main-cart-items.liquid (ff_gw_popular_cap). */
    var CAP = 6;
    /* FF 2026-08-22 [wip512 Fix 1]: real dedupe bug found live while verifying the cart
       category-tab fix -- this function only ever checked a candidate against tiles
       ALREADY IN THE GRID (existingHandles below) and `.avail`, never against the actual
       CART contents, so a v3 item could keep being upsold here after the shopper had
       already added it (confirmed live: adding the "6-Piece Wicker Sofa Set" rail pick to
       an outdoor cart, then reloading, still showed it as its own upsell). The Liquid
       fallback this function tops up already excludes cart items via `ff_gw_cart_handles`
       -- data-cart-handles carries that SAME server-computed list onto this root so this
       v3-sourced path gets the identical guard. */
    var cartHandleHay = "," + (root.getAttribute("data-cart-handles") || "").replace(/^,|,$/g, "") + ",";
    function ffGwInCart(h) { return !!h && cartHandleHay.indexOf("," + h + ",") !== -1; }
    var existingHandles = {};
    Array.prototype.forEach.call(grid.querySelectorAll(".ff-goeswith-tile"), function (t) {
      var a = t.querySelector(".ff-goeswith-tile-title");
      var href = a ? a.getAttribute("href") || "" : "";
      var m = href.match(/\/products\/([^/?#]+)/);
      if (m) existingHandles[m[1]] = true;
    });
    var frag = document.createDocumentFragment();
    var added = 0;
    entry.items.forEach(function (it) {
      if (added >= CAP) return;
      if (!it || !it.h || existingHandles[it.h]) return; /* already shown -- no duplicate tile */
      if (!it.avail) return; /* never recommend an out-of-stock companion */
      if (ffGwInCart(it.h)) return; /* wip512: never upsell something already in the cart */
      if (ffGwToneClash(anchorTone, ffGwTone(it.t))) return; /* wip493: never a hard finish clash */
      frag.appendChild(ffGwBuildFamilyTile(it));
      existingHandles[it.h] = true;
      added++;
    });
    if (!added) return;
    grid.insertBefore(frag, grid.firstChild);
    /* Trim from the END (the lowest-priority curated picks) to keep the total
       at the existing 5-card cap -- family matches always win a slot first. */
    while (grid.children.length > CAP) {
      grid.removeChild(grid.lastElementChild);
    }
    ffGwUpdateAddAll(root);
  }
  document.addEventListener("DOMContentLoaded", function () {
    ffGwInjectFamily();
    ffCartRailsFetchInitial();
    var gwRoot = document.querySelector("[data-ff-goeswith]");
    if (gwRoot && window.FFUpsellTrack) window.FFUpsellTrack.observeImpression(gwRoot);
  });

  /* ---------- FF 2026-08-17 [wip373 owner item 5] ----------
     Cart-scoped quick-view popup (snippets/ff-quickview-cart.liquid). Clicking a
     rail or category-popup card's image/title opens this instead of navigating to
     the PDP — every .ff-goeswith-tile (server-rendered by ff-goeswith-card.liquid,
     or JS-built by ffGwBuildFamilyTile above) carries a data-ff-qv JSON payload +
     a data-ff-qv-trigger marker on its two link elements; the real href on those
     links is kept for progressive enhancement (no-JS / JS error still reaches the
     real product page) and is intercepted here via preventDefault(). ---------- */
  var ffQvState = { images: [], index: 0 };
  function ffQvOverlay() { return document.getElementById("ff-quickview-cart-overlay"); }
  function ffQvRenderSlide() {
    var ov = ffQvOverlay();
    if (!ov) return;
    var track = ov.querySelector("[data-ff-qv-track]");
    if (track) {
      track.scrollTo({ left: ffQvState.index * track.clientWidth, behavior: "smooth" });
    }
    ov.querySelectorAll("[data-ff-qv-dots] .ff-qv-dot").forEach(function (dot, i) {
      dot.classList.toggle("is-active", i === ffQvState.index);
    });
  }
  function ffQvGoTo(i) {
    var n = ffQvState.images.length;
    if (!n) return;
    ffQvState.index = ((i % n) + n) % n;
    ffQvRenderSlide();
  }
  function ffQvOpen(payload) {
    var ov = ffQvOverlay();
    if (!ov || !payload) return;
    ffQvState.images = Array.isArray(payload.images) ? payload.images : [];
    ffQvState.index = 0;

    var track = ov.querySelector("[data-ff-qv-track]");
    if (track) {
      track.innerHTML = "";
      ffQvState.images.forEach(function (src) {
        var img = document.createElement("img");
        img.src = src;
        img.alt = payload.t || "";
        img.loading = "lazy";
        track.appendChild(img);
      });
    }
    var dotsWrap = ov.querySelector("[data-ff-qv-dots]");
    var prevBtn = ov.querySelector("[data-ff-qv-prev]");
    var nextBtn = ov.querySelector("[data-ff-qv-next]");
    var multi = ffQvState.images.length > 1;
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      dotsWrap.hidden = !multi;
      if (multi) {
        ffQvState.images.forEach(function (_, i) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "ff-qv-dot" + (i === 0 ? " is-active" : "");
          dot.setAttribute("aria-label", "Image " + (i + 1));
          dot.addEventListener("click", function () { ffQvGoTo(i); });
          dotsWrap.appendChild(dot);
        });
      }
    }
    if (prevBtn) prevBtn.hidden = !multi;
    if (nextBtn) nextBtn.hidden = !multi;

    var titleEl = ov.querySelector("[data-ff-qv-title]");
    if (titleEl) titleEl.textContent = payload.t || "";

    var priceEl = ov.querySelector("[data-ff-qv-price]");
    if (priceEl) priceEl.textContent = payload.price || "";
    var compareEl = ov.querySelector("[data-ff-qv-compare]");
    if (compareEl) {
      if (payload.compare) { compareEl.textContent = payload.compare; compareEl.hidden = false; }
      else { compareEl.textContent = ""; compareEl.hidden = true; }
    }

    var ratingWrap = ov.querySelector("[data-ff-qv-rating]");
    if (ratingWrap) {
      if (payload.rating && payload.rating > 0) {
        var pct = Math.max(0, Math.min(100, (payload.rating / 5) * 100));
        var fillEl = ov.querySelector("[data-ff-qv-rating-fill]");
        if (fillEl) fillEl.style.width = pct + "%";
        var numEl = ov.querySelector("[data-ff-qv-rating-num]");
        if (numEl) numEl.textContent = Number(payload.rating).toFixed(1);
        ratingWrap.hidden = false;
      } else {
        ratingWrap.hidden = true;
      }
    }

    var dimsEl = ov.querySelector("[data-ff-qv-dims]");
    if (dimsEl) {
      dimsEl.innerHTML = "";
      /* FF 2026-08-17 [wip373 owner item 5]: same "Label::value;;Label::value" string
         convention ff-goeswith-card.liquid builds (server-side, via a proven capture+
         split, not the array-of-objects encoding an earlier version of this payload
         used and lost data with) -- reusing the SAME parse already proven for
         #ff-rail-lightbox-dims a few hundred lines up in this file rather than a
         second, different array shape. */
      var rawDims = payload.dims || "";
      var dims = rawDims
        .split(";;")
        .filter(function (s) { return s.indexOf("::") > -1; })
        .map(function (s) {
          var parts = s.split("::");
          return { l: parts[0], v: parts.slice(1).join("::") };
        });
      if (dims.length) {
        dims.slice(0, 3).forEach(function (d) {
          var cell = document.createElement("div");
          cell.className = "ff-qv-dim";
          var lab = document.createElement("span");
          lab.className = "ff-qv-dim-label";
          lab.textContent = d.l || "";
          var val = document.createElement("span");
          val.className = "ff-qv-dim-value";
          val.textContent = d.v || "";
          cell.appendChild(lab);
          cell.appendChild(val);
          dimsEl.appendChild(cell);
        });
        dimsEl.hidden = false;
      } else {
        dimsEl.hidden = true;
      }
    }

    var descEl = ov.querySelector("[data-ff-qv-desc]");
    if (descEl) {
      if (payload.desc) { descEl.textContent = payload.desc; descEl.hidden = false; }
      else { descEl.textContent = ""; descEl.hidden = true; }
    }

    var addBtn = ov.querySelector("[data-ff-qv-add]");
    if (addBtn) {
      addBtn.dataset.variantId = payload.vid || "";
      addBtn.disabled = !payload.vid;
      var addLabel = addBtn.querySelector("[data-ff-qv-add-label]");
      if (addLabel) addLabel.textContent = "Add to cart";
    }
    var fullLink = ov.querySelector("[data-ff-qv-fulllink]");
    if (fullLink) fullLink.href = payload.url || "#";

    ov.hidden = false;
    ffQvRenderSlide();
  }
  function ffQvClose() {
    var ov = ffQvOverlay();
    if (ov) ov.hidden = true;
  }
  window.addEventListener("resize", function () {
    var ov = ffQvOverlay();
    if (ov && !ov.hidden) ffQvRenderSlide();
  });

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-ff-qv-trigger]");
    if (trigger) {
      var tile = trigger.closest(".ff-goeswith-tile");
      var raw = tile ? tile.getAttribute("data-ff-qv") : null;
      if (!raw) return; /* no payload — let the real href navigate (progressive enhancement) */
      var payload;
      try { payload = JSON.parse(raw); } catch (e) { return; }
      event.preventDefault();
      if (window.FFUpsellTrack && tile) window.FFUpsellTrack.trackClick(tile);
      ffQvOpen(payload);
      return;
    }
    if (event.target.closest("[data-ff-qv-prev]")) { ffQvGoTo(ffQvState.index - 1); return; }
    if (event.target.closest("[data-ff-qv-next]")) { ffQvGoTo(ffQvState.index + 1); return; }
    if (event.target.closest("#ff-qv-close") || event.target.id === "ff-quickview-cart-overlay") {
      ffQvClose();
      return;
    }
  });

  /* swipe support — basic horizontal-delta touch gesture, matches the
     scroll-snap track's own native swipe (this just syncs the dots/state
     after a manual scroll finishes, since the track also scrolls natively). */
  document.addEventListener(
    "scroll",
    function (event) {
      var track = event.target.closest && event.target.closest("[data-ff-qv-track]");
      if (!track) return;
      window.clearTimeout(track.__ffQvScrollTimer);
      track.__ffQvScrollTimer = window.setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== ffQvState.index) {
          ffQvState.index = i;
          var ov = ffQvOverlay();
          if (ov) {
            ov.querySelectorAll("[data-ff-qv-dots] .ff-qv-dot").forEach(function (dot, di) {
              dot.classList.toggle("is-active", di === i);
            });
          }
        }
      }, 100);
    },
    true
  );

  /* quick-view's own Add button — same fetch/toast/refresh pattern as every
     other add-to-cart surface on this page (.ff-rail-lightbox-add above). */
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-ff-qv-add]");
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: "cart-drawer,cart-icon-bubble" })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        btn.disabled = false;
        if (response.status) {
          console.error("FF cart: quick-view add failed", response);
          return;
        }
        ffQvClose();
        ffCartAfterAdd(response);
        refreshCartSections();
      })
      .catch(function (e) {
        btn.disabled = false;
        console.error("FF cart: quick-view add failed", e);
      });
  });

  /* ---------- coverage modal (single instance, class-based openers) ---------- */
  document.addEventListener("click", function (event) {
    var openBtn = event.target.closest(".ff-warranty-modal-open");
    if (openBtn) {
      event.preventDefault();
      event.stopPropagation();
      var overlay = document.getElementById("ff-warranty-modal-overlay");
      if (overlay) overlay.hidden = false;
      return;
    }
    var closeBtn = event.target.closest("#ff-warranty-modal-close");
    var onOverlay = event.target.id === "ff-warranty-modal-overlay";
    if (closeBtn || onOverlay) {
      var ov = document.getElementById("ff-warranty-modal-overlay");
      if (ov) ov.hidden = true;
    }
  });
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var overlay = document.getElementById("ff-warranty-modal-overlay");
    if (overlay && !overlay.hidden) overlay.hidden = true;
    var lightbox = document.getElementById("ff-rail-lightbox");
    if (lightbox && !lightbox.hidden) lightbox.hidden = true;
    /* wip373 item 5 */
    var qv = document.getElementById("ff-quickview-cart-overlay");
    if (qv && !qv.hidden) qv.hidden = true;
  });

  /* ---------- rail-card lightbox (wave-4) ----------
     Rail cards never navigate off the cart; tapping the image opens this
     small in-page dialog (bigger contain-fit look, title + price, X /
     overlay / Esc close). Delegated, so it survives section refreshes. */
  document.addEventListener("click", function (event) {
    var imgBtn = event.target.closest("[data-ff-lightbox]");
    if (imgBtn) {
      event.preventDefault();
      var ov = document.getElementById("ff-rail-lightbox");
      if (!ov) return;
      var img = ov.querySelector(".ff-rail-lightbox-img");
      if (img) {
        img.src = imgBtn.dataset.img || "";
        img.alt = imgBtn.dataset.title || "";
      }
      var titleEl = ov.querySelector(".ff-rail-lightbox-title");
      if (titleEl) titleEl.textContent = imgBtn.dataset.title || "";
      var priceEl = ov.querySelector(".ff-rail-lightbox-price");
      if (priceEl) priceEl.textContent = imgBtn.dataset.price || "";
      /* wip283 (owner review pass, 2026-08-14, item 6): review stars — only when
         the trigger button actually carries a real rating (server-side gate in
         sections/main-cart-items.liquid: product_schema.th_ratingValue/
         th_ratingCount, >=10 reviews; the fabricated ffc.rating seed used
         elsewhere on the site is never read for this). data-rating is "0" (falsy
         after parseFloat) whenever the product doesn't qualify, so the row just
         stays hidden — never a blank/zero star row. Built with textContent, not
         innerHTML: the only dynamic value is a number. */
      var ratingEl = ov.querySelector("#ff-rail-lightbox-rating");
      if (ratingEl) {
        var ratingVal = parseFloat(imgBtn.dataset.rating || "0");
        var ratingCount = parseInt(imgBtn.dataset.ratingCount || "0", 10);
        ratingEl.innerHTML = "";
        if (ratingVal > 0 && ratingCount > 0) {
          var STAR_PATH =
            "M12 1.8l3.07 6.22 6.87 1-4.97 4.84 1.17 6.84L12 17.47 5.86 20.7l1.17-6.84L2.06 9.02l6.87-1z";
          var pct = Math.max(0, Math.min(100, (ratingVal / 5) * 100));
          var starsWrap = document.createElement("span");
          starsWrap.className = "ff-rail-lightbox-stars";
          function buildRow(isFill) {
            var row = document.createElement("span");
            row.className = "ff-rail-lightbox-stars-row" + (isFill ? " ff-rail-lightbox-stars-row--fill" : "");
            if (isFill) row.style.width = pct + "%";
            for (var i = 0; i < 5; i++) {
              var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
              svg.setAttribute("viewBox", "0 0 24 24");
              svg.setAttribute("aria-hidden", "true");
              var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
              path.setAttribute("d", STAR_PATH);
              svg.appendChild(path);
              row.appendChild(svg);
            }
            return row;
          }
          starsWrap.appendChild(buildRow(false));
          starsWrap.appendChild(buildRow(true));
          var numEl = document.createElement("span");
          numEl.className = "ff-rail-lightbox-rating-num";
          numEl.textContent = ratingVal.toFixed(1);
          var countEl = document.createElement("span");
          countEl.className = "ff-rail-lightbox-rating-count";
          countEl.textContent = "(" + ratingCount + (ratingCount === 1 ? " review" : " reviews") + ")";
          ratingEl.appendChild(starsWrap);
          ratingEl.appendChild(numEl);
          ratingEl.appendChild(countEl);
          ratingEl.hidden = false;
        } else {
          ratingEl.hidden = true;
        }
      }
      /* wave-5: hand the card's variant id to the lightbox Add button */
      var addBtn = ov.querySelector(".ff-rail-lightbox-add");
      if (addBtn) {
        addBtn.dataset.variantId = imgBtn.dataset.variantId || "";
        addBtn.disabled = !imgBtn.dataset.variantId;
      }
      /* wave-7 (owner item 3, 2026-08-13): up to 3 key-figure cells (Width /
         Height / Material), built server-side into data-dims as
         "Label::value;;Label::value;;...". Only shown when >=2 figures came
         through — never prints a blank or invented figure. Built with
         createElement/textContent (not innerHTML) since the values are
         real product data (title/material text), not markup. */
      var dimsEl = ov.querySelector("#ff-rail-lightbox-dims");
      if (dimsEl) {
        var rawDims = imgBtn.dataset.dims || "";
        var pairs = rawDims
          .split(";;")
          .filter(function (s) { return s.indexOf("::") > -1; })
          .map(function (s) {
            var parts = s.split("::");
            return { label: parts[0], value: parts.slice(1).join("::") };
          });
        dimsEl.textContent = "";
        if (pairs.length >= 2) {
          pairs.slice(0, 3).forEach(function (p) {
            var cell = document.createElement("div");
            cell.className = "ff-rail-lightbox-dim";
            var lab = document.createElement("span");
            lab.className = "ff-rail-lightbox-dim-label";
            lab.textContent = p.label;
            var val = document.createElement("span");
            val.className = "ff-rail-lightbox-dim-value";
            val.textContent = p.value;
            cell.appendChild(lab);
            cell.appendChild(val);
            dimsEl.appendChild(cell);
          });
          dimsEl.hidden = false;
        } else {
          dimsEl.hidden = true;
        }
      }
      var viewFullEl = ov.querySelector("#ff-rail-lightbox-viewfull");
      if (viewFullEl) viewFullEl.href = imgBtn.dataset.url || "#";
      ov.hidden = false;
      return;
    }
    if (event.target.closest(".ff-rail-lightbox-close") || event.target.id === "ff-rail-lightbox") {
      var lb = document.getElementById("ff-rail-lightbox");
      if (lb) lb.hidden = true;
    }
  });

  /* ---------- rail-card lightbox image preload on hover/touch intent (wip283
     owner review pass, 2026-08-14, item 5) ----------
     Owner: "can we make the popup a little bit quicker... the photo load
     faster when I click the magnifying glass?" Root cause, measured live on
     WIP theme 191898976578, real cart, real CDN host (no code changed yet):
     the big (width=900) lightbox image was never fetched until THIS click
     handler set img.src, so the click always paid the full network cost.
     Measured click-to-loaded latency with no preload: 1094ms / 1053ms / 1241ms
     across 3 different rail products (Scantor lamp, Hallburg lamp, Scarbot
     lamp). Fix: start fetching the SAME url the click handler will use the
     moment real intent is detectable, so the network cost happens while the
     shopper is still hovering/tapping, not after they click. Measured with
     the identical technique used here (warm a `new Image()` first, then
     click): click-to-loaded latency dropped to 7ms — a cache hit, no network
     round trip at click time. `pointerover` bubbles (unlike `pointerenter`)
     so one delegated listener covers every card; it also fires immediately
     before a touch tap in Chrome/Safari, and `touchstart` is added as a
     redundant net for browsers where it doesn't. A WeakSet guard means each
     product's big image is only ever requested once per page life — hovering
     back and forth over the same card doesn't refetch it. */
  var ffLightboxPreloaded = typeof WeakSet !== "undefined" ? new WeakSet() : null;
  function ffPreloadLightboxImg(btn) {
    if (!btn) return;
    var src = btn.dataset.img;
    if (!src) return;
    if (ffLightboxPreloaded) {
      if (ffLightboxPreloaded.has(btn)) return;
      ffLightboxPreloaded.add(btn);
    } else if (btn.dataset.ffPreloaded) {
      return;
    } else {
      btn.dataset.ffPreloaded = "1";
    }
    var pre = new Image();
    pre.src = src;
  }
  document.addEventListener("pointerover", function (event) {
    var btn = event.target.closest && event.target.closest("[data-ff-lightbox]");
    if (btn) ffPreloadLightboxImg(btn);
  });
  document.addEventListener(
    "touchstart",
    function (event) {
      var btn = event.target.closest && event.target.closest("[data-ff-lightbox]");
      if (btn) ffPreloadLightboxImg(btn);
    },
    { passive: true }
  );

  /* ---------- lightbox Add to cart (wave-5, owner item 4) ----------
     Adds the previewed rail product, closes the lightbox, opens the cart
     drawer (wave 6 — was a toast), then refreshes the cart sections. Delegated. */
  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".ff-rail-lightbox-add");
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: "cart-drawer,cart-icon-bubble" }),
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        btn.disabled = false;
        if (response.status) {
          console.error("FF cart: lightbox add failed", response);
          return;
        }
        var lb = document.getElementById("ff-rail-lightbox");
        if (lb) lb.hidden = true;
        ffCartAfterAdd(response);
        refreshCartSections();
      })
      .catch(function (e) {
        btn.disabled = false;
        console.error("FF cart: lightbox add failed", e);
      });
  });

  /* ---------- protection-box toggle (v2.2, W3 box) ----------
     Checkbox adds the resolved warranty variant with DEDUPE: if the box is
     already in its protected state (warranty in cart — resolved variant OR a
     legacy Guardsman product, per the Liquid render), a click acts as an
     un-tick (removes the resolved variant) and can never add a second line.
     Both breakpoint copies of the box are kept visually in sync optimistically,
     then re-rendered from the server by refreshCartSections. */
  var ffProtectBusy = false;
  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".ff-protect-toggle");
    if (!btn || ffProtectBusy) return;
    event.preventDefault();
    var box = btn.closest(".ff-protect-box");
    if (!box) return;
    var variantId = btn.dataset.variantId;
    var willAdd = !box.classList.contains("is-protected");
    // FF wip545 (2026-09-03) coordinator item (a): hidden _guardsman_plan line-item
    // property, same reasoning as the PDP/drawer add paths (see ff-main-product-ext.js
    // and cart-drawer.liquid's own comments on this).
    var warPlan = btn.dataset.guardsmanPlan || "Elite";

    document.querySelectorAll(".ff-protect-box").forEach(function (b) {
      b.classList.toggle("is-protected", willAdd);
      var confirmEl = b.querySelector(".ff-protect-confirm");
      if (confirmEl) confirmEl.hidden = !willAdd;
      var t = b.querySelector(".ff-protect-toggle");
      if (t) t.setAttribute("aria-pressed", willAdd ? "true" : "false");
    });

    /* wave-4: INSTANT optimistic UI — subtotal, monthly number, sticky-bar
       total, every item count and the left item list all flip before the
       network round-trip; refreshCartSections reconciles from the server
       right after. Savings is untouched (the plan has no compare-at price). */
    var priceCents = parseInt(btn.dataset.priceCents || "0", 10);
    var delta = willAdd ? priceCents : -priceCents;
    var subEl = document.querySelector(".ff-rail-row--subtotal span:last-child");
    if (subEl && priceCents > 0) {
      var newSubtotal = ffParseCents(subEl.textContent) + delta;
      if (newSubtotal < 0) newSubtotal = 0;
      document.querySelectorAll(".ff-rail-row--subtotal span:last-child").forEach(function (el) {
        el.textContent = ffFmtMoney(newSubtotal);
      });
      document.querySelectorAll(".ff-rail-monthly-amount").forEach(function (el) {
        var node = el.firstChild;
        if (node && node.nodeType === 3) node.nodeValue = ffFmtMoney(Math.floor(newSubtotal / 12));
      });
      var stickyStrong = document.querySelector(".ff-cart-sticky-bar-total strong");
      if (stickyStrong) stickyStrong.textContent = ffFmtMoney(newSubtotal);
    }
    /* the plan itself carries a compare-at price, so the savings line moves too */
    var compCents = parseInt(btn.dataset.compareCents || "0", 10);
    if (compCents > priceCents) {
      var savDelta = (compCents - priceCents) * (willAdd ? 1 : -1);
      document.querySelectorAll(".ff-rail-savings").forEach(function (el) {
        var newSav = ffParseCents(el.textContent) + savDelta;
        if (newSav < 0) newSav = 0;
        el.textContent = "You're saving " + ffFmtMoney(newSav) + " 🎉";
      });
      /* wip415: the stacked sticky bar now shows the savings figure too -- keep it live. */
      document.querySelectorAll(".ff-cart-sticky-bar-savings").forEach(function (el) {
        var newBarSav = ffParseCents(el.textContent) + savDelta;
        if (newBarSav < 0) newBarSav = 0;
        el.textContent = ffFmtMoney(newBarSav);
      });
    }
    var bar = document.getElementById("ff-cart-sticky-bar");
    if (bar) {
      var n = parseInt(bar.dataset.itemCount || "0", 10) + (willAdd ? 1 : -1);
      if (n < 0) n = 0;
      bar.dataset.itemCount = String(n);
      var nLabel = n + (n === 1 ? " item" : " items");
      var barSpan = bar.querySelector(".ff-cart-sticky-bar-total span");
      if (barSpan) barSpan.textContent = nLabel; /* wip415: stacked bar, line 1 is just the count */
      var headerCountEl = document.querySelector(".ff-cart-header-count [data-ff-header-count]");
      if (headerCountEl) headerCountEl.textContent = nLabel;
      var titleEl = document.querySelector(".ff-cart-title");
      if (titleEl) titleEl.textContent = "Your cart · " + nLabel;
    }
    if (willAdd) {
      var tpl = document.querySelector("[data-ff-optimistic-warranty]");
      if (tpl) tpl.hidden = false;
    } else {
      document.querySelectorAll(".ff-cart-row--warranty").forEach(function (row) {
        row.hidden = true;
      });
    }

    ffProtectBusy = true;
    var req = willAdd
      ? fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: { "_guardsman_plan": warPlan } }),
        })
      : fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 0 }),
        });

    req.then(function () { refreshCartSections(function () { ffProtectBusy = false; }); })
      .catch(function (e) {
        ffProtectBusy = false;
        console.error("FF cart: protection toggle failed", e);
      });
  });

  /* FF 2026-08-14 [wip314 goeswith]: the old "rail add (small dark icon
     button)" handler lived here (.ff-upsell-add). Superseded by
     assets/ff-cart-goeswith.js's own .ff-goeswith-tile-add / Add-all
     handlers, which reuse window.FFCart.afterAdd/refreshCartSections below
     instead of calling ffCartAfterAdd/refreshCartSections directly. */

  /* ---------- sticky mini-summary bar ----------
     Desktop + mobile; gated on cart.item_count >= 2; hides while the relevant
     main summary (.ff-cart-rail on desktop, #ff-cart-mobile-summary on mobile)
     is in view. */
  var stickyObserver = null;
  function initStickyBar() {
    var bar = document.getElementById("ff-cart-sticky-bar");
    if (!bar) return;
    var itemCount = parseInt(bar.dataset.itemCount || "0", 10);
    if (stickyObserver) stickyObserver.disconnect();
    if (!itemCount || itemCount < 2) {
      bar.classList.remove("is-visible");
      return;
    }
    var isDesktop = window.matchMedia("(min-width: 990px)").matches;
    var target = isDesktop
      ? document.querySelector(".ff-cart-rail")
      : document.getElementById("ff-cart-mobile-summary");
    if (!target) {
      bar.classList.remove("is-visible");
      return;
    }
    stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle("is-visible", !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    stickyObserver.observe(target);
  }

  document.addEventListener("DOMContentLoaded", initStickyBar);
  window.addEventListener("resize", initStickyBar);

  /* ---------- FF 2026-08-17 [wip332 cart-fix, bugs 1+2] ----------
     BUG: removing an item (or changing qty) via the theme-stock cart-remove-button /
     quantity-input controls (assets/cart.js CartItems.updateQuantity) only ever swaps
     #main-cart-items .js-contents -- the desktop rail (.ff-cart-rail), the mobile
     summary cards, and the "Goes with X" block all live OUTSIDE .js-contents in this
     section (see SPEC/CART.md §1), so none of them ever picked up the new cart state:
     subtotal/savings/monthly/delivery stayed frozen at the pre-removal numbers, and the
     goes-with rail kept pointing at a product that may no longer be in the cart.
     FIX: stock cart.js already dispatches a real "cart:updated" CustomEvent (detail:
     {itemCount}) at the end of EVERY successful remove/qty-change -- listen for it and
     call the SAME refreshCartSections() the add-to-cart and protection-toggle paths
     already use (proven correct: full .ff-cart-grid replace -> rail + mobile summary +
     goes-with all re-rendered from a fresh server pass, re-anchoring "Goes with X" to
     whatever remains in the cart, since the anchor is recomputed in Liquid on every
     render). Guarded against ffCartAfterAdd()'s OWN "cart:updated" dispatch (detail:
     {source:"ff-cart-page-add"}) so an add doesn't trigger a redundant second refresh --
     that path already calls refreshCartSections() itself right after. The companion fix
     for the error toast ("There was an error while updating your cart...") is a
     one-line guard in assets/cart.js around an unrelated pre-existing bug (an undefined
     checkAndToggleExtraProduct() call left over from a legacy PDP-only upsell flow) --
     not duplicated here. ---------- */
  document.addEventListener("cart:updated", function (event) {
    if (event.detail && event.detail.source === "ff-cart-page-add") return;
    refreshCartSections();
  });

  /* FF 2026-08-14 [wip314 goeswith]: initUpsellRails() (category rail arrow
     scroll logic) lived here -- removed with the old "Finish the room" rails
     it drove. The new "goes with" tile row either fits in one line (desktop)
     or scrolls natively (mobile, CSS-only scroll-snap, no JS arrows needed
     for only ~5 tiles); see assets/ff-cart-goeswith.js for its init. */

  /* ---------- save/share cart (class-based; two DOM copies) ----------
     Interim capture only — POSTs to Shopify's own contact form endpoint
     (shows up in Admin > Inbox); no bespoke quote flow yet. The block is a
     <div> inside the outer <form id="cart"> (nested <form> would be invalid
     HTML), so the body is built by hand here.
     wave-5 (owner item 6): PHONE input added — EITHER contact works. Email
     goes in contact[email]; phone goes in contact[phone] AND is echoed in
     contact[body] so it is visible even where Inbox hides the phone field. */
  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".ff-savecart-btn");
    if (!btn) return;
    var wrap = btn.closest(".ff-savecart-form");
    if (!wrap) return;
    var emailInput = wrap.querySelector(".ff-savecart-email");
    var phoneInput = wrap.querySelector(".ff-savecart-phone");
    var block = wrap.closest(".ff-savecart-block");
    var confirmEl = block ? block.querySelector(".ff-savecart-confirm") : null;
    if (!emailInput) return;
    var email = emailInput.value.trim();
    var phone = phoneInput ? phoneInput.value.trim() : "";
    var phoneDigits = phone.replace(/[^0-9]/g, "");

    emailInput.setCustomValidity("");
    if (phoneInput) phoneInput.setCustomValidity("");
    if (!email && !phone) {
      emailInput.setCustomValidity("Enter an email or a phone number.");
      emailInput.reportValidity();
      return;
    }
    if (email && !emailInput.checkValidity()) {
      emailInput.reportValidity();
      return;
    }
    if (phone && phoneDigits.length < 7 && phoneInput) {
      phoneInput.setCustomValidity("That phone number looks too short.");
      phoneInput.reportValidity();
      return;
    }

    var note = "Save/share cart request from " + wrap.dataset.cartUrl;
    if (phone) note += " | Phone: " + phone;
    if (!email) note += " | No email given - customer asked for the cart link by phone.";
    var body = new URLSearchParams();
    body.set("form_type", "contact");
    body.set("utf8", "✓");
    body.set("contact[email]", email);
    if (phone) body.set("contact[phone]", phone);
    body.set("contact[body]", note);
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Sending...";

    /* wave-5: Shopify can reject tokenless AJAX /contact posts with 400
       "Missing CAPTCHA token" (observed 2026-08-12 — it also kills the old
       email-only path). Fallback: copy the values into the REAL hidden
       {% form 'contact' %} and native-submit so Shopify runs its own captcha
       challenge and brings the customer back to the cart. */
    function nativeFallback() {
      var native = document.getElementById("ff-savecart-native");
      if (!native) return false;
      var set = function (name, v) {
        var input = native.querySelector('[name="' + name + '"]');
        if (input) input.value = v;
      };
      set("contact[email]", email);
      set("contact[phone]", phone);
      set("contact[body]", note);
      /* FF 2026-08-14 [wip321 captcha-fix]: HTMLFormElement.submit() never fires the
       form's submit event, so Shopify's captcha-binding script never attaches a
       token and the post 400s with "Missing CAPTCHA token" for every submitter,
       every time. requestSubmit() fires that event; very old browsers without it
       click the hidden submit button added to the form markup instead, which also
       fires it -- never falling back to submit() again. */
      if (typeof native.requestSubmit === "function") {
        native.requestSubmit();
      } else {
        var btn = native.querySelector("button");
        if (btn) btn.click();
      }
      return true; /* page navigates — no UI reset needed */
    }

    fetch(wrap.dataset.action, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    })
      .then(function (r) {
        /* a redirect that lands on Shopify's /challenge page means the post
           was NOT accepted yet — that path needs the real navigation too */
        var challenged = ((r.url || "").indexOf("/challenge") !== -1);
        if ((r.ok || r.redirected) && !challenged) {
          btn.disabled = false;
          btn.textContent = originalText;
          emailInput.value = "";
          if (phoneInput) phoneInput.value = "";
          if (confirmEl) confirmEl.hidden = false;
          return;
        }
        if (!nativeFallback()) {
          btn.disabled = false;
          btn.textContent = originalText;
          console.error("FF cart: save-cart rejected", r.status);
        }
      })
      .catch(function (e) {
        console.error("FF cart: save-cart submit failed", e);
        if (!nativeFallback()) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
      });
  });

  /* back on /cart after a successful native contact post: show the confirms */
  document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector("[data-ff-savecart-posted]")) return;
    document.querySelectorAll(".ff-savecart-confirm").forEach(function (el) { el.hidden = false; });
  });

  /* FF 2026-08-14 [wip314 goeswith]: expose the shared post-add + section-
     refresh helpers so assets/ff-cart-goeswith.js (new "Goes with X" upsell
     block, loaded right after this file, defer) can reuse the SAME drawer-
     sync/open/toast-fallback/section-refresh machinery every other
     add-to-cart surface on this page already uses, instead of
     re-implementing it a second time. Purely additive -- nothing above this
     line changes behavior. ff-cart-goeswith.js sets window.FFCart.initGoesWith
     (called from refreshCartSections above); this file never calls it
     directly, only guards for its presence. */
  window.FFCart = window.FFCart || {};
  window.FFCart.afterAdd = ffCartAfterAdd;
  window.FFCart.refreshCartSections = refreshCartSections;
})();
